import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Фиолетовая подсветка активного поля фильтра / сортировки / поиска. */
export const activeFilterFieldClass =
  'border-violet-400/65 bg-violet-500/10 ring-1 ring-violet-400/25'

/** Подсветка для «ссылочных» фильтров без рамки (главная страница). */
export const activeFilterLinkClass =
  'rounded-sm bg-violet-500/15 px-1 text-violet-700 dark:text-violet-300'

/**
 * Извлекает сообщение об ошибке из ответа API (FastAPI: detail — строка или массив ошибок валидации).
 */
export function parseApiErrorDetail(detail: unknown, fallback: string): string {
  if (typeof detail === 'string') return detail
  if (Array.isArray(detail) && detail.length > 0) {
    const first = detail[0] as { msg?: string }
    if (typeof first?.msg === 'string') return first.msg
  }
  return fallback
}

/**
 * Получить текущую дату в UTC в формате YYYY-MM-DD
 * @returns Строка с датой в формате YYYY-MM-DD
 */
export function getTodayDateUTC(): string {
  const now = new Date()
  // Используем UTC время
  const year = now.getUTCFullYear()
  const month = String(now.getUTCMonth() + 1).padStart(2, '0')
  const day = String(now.getUTCDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
